import { render } from "./splitMenuOrder.vue?vue&type=template&id=a46ddbbe"
import script from "./splitMenuOrder.vue?vue&type=script&lang=js"
export * from "./splitMenuOrder.vue?vue&type=script&lang=js"

import exportComponent from "/home/admindb/web/crevent.pedasabis.com/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__